import React, { FC } from "react";
import { Field } from "react-final-form";
import { Grid } from "@material-ui/core";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import Autocomplete from "../../../../../components/Autocomplete";
import { LANGUAGES } from "../../../constants";
import { ICourseComponentProps } from "../../../types";

interface ILanguageProps extends ICourseComponentProps {
  disabled?: boolean;
}

const Language: FC<ILanguageProps> = ({
  fieldsGroupName,
  errors,
  disabled = false,
}) => (
  <div>
    <FieldsGroupLabel
      isRequired
      label="Language"
      hasError={!!errors?.language}
      className="fields-group-label-first"
    />
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={6}>
        <Field
          fullWidth
          disabled={disabled}
          options={LANGUAGES}
          groupBy={(option) => option.popularity}
          getOptionLabel={(option) => option.name}
          placeholder="Please select"
          name={`${fieldsGroupName}.language`}
          component={Autocomplete}
        />
      </Grid>
    </Grid>
  </div>
);

export default React.memo(Language);
